<template>
  <a-card class="auto-height">
    <a-row :gutter="20">
      <a-col
        :xxl="5"
        :xl="8"
        :lg="9"
        :md="24"
        :sm="24"
        class="first-col">
        <a-row :gutter="8">
          <a-col :lg="20" :md="24">
            <a-input-search style="margin-bottom: 1rem" placeholder="Launcher提供商名称搜索" @change="onChange"/>
          </a-col>
          <a-col :lg="4" :md="24">
            <a-button type="primary" icon="plus" @click="handleAddOrEditVendor()"/>
          </a-col>
        </a-row>
        <a-list
          itemLayout="horizontal"
          :loading="loading"
          :dataSource="vendors">
          <a-list-item slot="renderItem" slot-scope="item, index" class="vendor-item" @click="(e) => handleClick(e, item)">
            <a-icon slot="actions" type="edit" class="action" @click="handleAddOrEditVendor(item)"/>
            <a-icon v-if="!item.hotels || item.hotels.length === 0" slot="actions" type="delete" class="action" @click="handleRemoveVendor(item)"/>
            <a-list-item-meta>
              <LauncherSvg slot="avatar" class="avatar"/>
              <div slot="title">{{ item.name }}</div>
              <div slot="description" class="desc">
                <div>地址：<ellipsis :length="17" tooltip>{{ item.address || '无' }}</ellipsis></div>
                <div>联系方式：<ellipsis :length="12" tooltip>{{ item.contact || '无' }}</ellipsis></div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-col>

      <a-col
        v-if="!this.lastItem"
        :xxl="19"
        :xl="16"
        :lg="15"
        :md="24"
        :sm="24">
        <div class="center blank">
          <div class="blank-intro">第三方Launcher提供商可以关联一家或多家酒店</div>
          <div class="blank-tip">请先在左侧选择提供商</div>
        </div>
      </a-col>

      <a-col
        v-else
        :xxl="19"
        :xl="16"
        :lg="15"
        :md="24"
        :sm="24">
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="酒店">
            <div class="hotel-button-wrapper">
              <a-button type="primary" :disabled="!this.lastItem" class="hotel-button" @click="handleAddHotel">添加关联酒店</a-button>
            </div>
            <a-table
              :loading="tableLoading"
              :columns="columns"
              :scroll="{ x: 720 }"
              :rowKey="record => record.id"
              :dataSource="hotelList"
              :pagination="false">
              <template slot="apk" slot-scope="text">
                <div v-for="item in text" :key="item" class="table-tag">
                  <a-tag><a-icon type="android" style="margin-right: 4px;"/>{{ item }}</a-tag>
                </div>
              </template>
              <span slot="max" slot-scope="record">
                <span :style="{ color: record.cost >= record.max ? 'red' : 'green' }">{{ record.cost }}</span>
                <span style="margin: auto 4px; color: rgba(0, 0, 0, .45)">/</span>
                <span>{{ record.max }}</span>
              </span>
              <span slot="code" slot-scope="record">
                <a v-if="!record.code" :disabled="disabled" @click="handleGrantCode(record)">生成验证码</a>
                <div v-else>
                  <span class="code-action">{{ record.code }}
                    <!--<a :disabled="disabled" title="刷新验证码" @click="handleRegrant(record)"><a-icon type="reload" :spin="spinning"/></a>-->
                    <a :disabled="disabled" title="回收验证码" @click="handleRecycleCode(record)"><a-icon type="delete"/></a>
                  </span>
                </div>
              </span>
              <a-row slot="expandedRowRender" slot-scope="record" class="table-render">
                <a-col :lg="8" :md="24">
                  <span><b>联系方式：</b>{{ record.contact || '无' }}</span>
                </a-col>
                <a-col :lg="16" :md="24">
                  <span><b>地址：</b>{{ record.address || '无' }}</span>
                </a-col>
              </a-row>
              <span slot="action" slot-scope="record">
                <a @click="handleEditHotel(record)">编辑</a>
                <a-divider type="vertical"/>
                <a style="color: red" @click="handleRemoveHotel(record)">删除</a>
              </span>
            </a-table>
          </a-tab-pane>

          <a-tab-pane key="2" tab="APK">
            <div class="apk-panel">
              <template v-for="apk in apkList">
                <a-tag :key="apk" closable @close="e => handleClose(e, apk)">
                  <a-icon type="android" style="margin-right: 8px;"/>{{ apk }}
                </a-tag>
              </template>
              <a-input
                v-if="visible.input"
                ref="input"
                type="text"
                placeholder="回车确认，ESC取消"
                class="apk-input"
                @keyup.esc="handleInputCancel"
                @keyup.enter="handleInputConfirm"/>
              <a-tag v-else class="apk-input-tag" @click="showInput">
                <a-icon type="plus" style="margin-right: 8px;"/>增加包名
              </a-tag>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>

    <AppVendorModal :visible.sync="visible.vendorModal" ref="avm" @ok="handleOK"/>
    <HotelModal :visible.sync="visible.hotelModal" :id="vendorId" :apk="apkList" ref="hm" @ok="handleOK2"/>
  </a-card>
</template>

<script>
import { listAllVendors, removeAppVendor, removeHotel, addApk, removeApk, grantHotelCode, recycleHotelCode } from '@/api/vendor'
import { mixinDevice } from '@/utils/mixin'
import AppVendorModal from './modal/AppVendorModal'
import HotelModal from './modal/HotelModal'
import { Ellipsis } from '@/components'
import LauncherSvg from '@/assets/launcher.svg?inline'

export default {
  components: {
    Ellipsis,
    HotelModal,
    AppVendorModal,
    LauncherSvg
  },
  mixins: [mixinDevice],
  data: function () {
    return {
      loading: false,
      tableLoading: false,
      visible: {
        vendorModal: false,
        hotelModal: false,
        input: false
      },
      disabled: false,
      spinning: false,
      keyword: '',
      lastItem: null,
      vendorId: '',
      vendorList: [],
      hotelList: [],
      apkList: [],
      closing: false,
      columns: [{
        title: '酒店名称',
        width: 140,
        dataIndex: 'hotelName'
      }, {
        title: 'APK',
        dataIndex: 'apk',
        scopedSlots: { customRender: 'apk' }
      }, {
        title: '已激活/总授权数量',
        scopedSlots: { customRender: 'max' }
      }, {
        title: '验证码',
        width: 95,
        scopedSlots: { customRender: 'code' }
      }, {
        title: '操作',
        width: 110,
        fixed: 'right',
        scopedSlots: { customRender: 'action' }
      }]
    }
  },
  computed: {
    vendors () {
      if (this.keyword) {
        return this.vendorList.filter(v => v.name.indexOf(this.keyword) > -1)
      } else {
        return this.vendorList
      }
    }
  },
  mounted () {
    this.loadVendor()
  },
  methods: {
    handleClick (e, vendor) {
      this.vendorId = vendor.id
      if (this.lastItem && this.lastItem !== e.currentTarget) {
        this.lastItem.classList.remove('vendor-item-active')
      }
      e.currentTarget.classList.add('vendor-item-active')
      this.lastItem = e.currentTarget
      this.hotelList = (vendor.hotels || []).sort((a, b) => a.sort - b.sort)
      this.apkList = vendor.apk || []
    },

    loadVendor (keepSelect) {
      if (!keepSelect) {
        this.vendorId = ''
        this.lastItem = null
      }
      this.loading = true
      listAllVendors().then(response => {
        this.vendorList = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    onChange (e) {
      const value = e.target.value
      if (value) {
        this.keyword = value.trim()
        if (this.keyword && this.lastItem) {
          this.lastItem.classList.remove('vendor-item-active')
        }
      } else {
        this.keyword = ''
      }
    },

    handleTableChange (pagination, filters, sorter) {
      this.query.pageNumber = pagination.current
      this.query.pageSize = pagination.pageSize
    },

    handleAddOrEditVendor (vendor) {
      this.visible.vendorModal = true
      if (vendor) {
        this.$nextTick(() => this.$refs.avm.load(vendor))
      }
    },

    handleRemoveVendor (record) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
            确定要删除第三方Launcher提供商<span style="font-weight: 600"> { record.name } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          removeAppVendor(record.id).then(response => {
            _this.$message.success(response.msg)
            _this.loadVendor()
            modal.destroy()
          }).catch(err => {
            console.log(err)
          })
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    handleAddHotel () {
      this.visible.hotelModal = true
    },

    handleEditHotel (hotel) {
      this.visible.hotelModal = true
      this.$nextTick(() => this.$refs.hm.load(hotel))
    },

    handleRemoveHotel (hotel) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
            确定要删除<span style="font-weight: 600"> { hotel.hotelName } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          removeHotel(hotel.uuid).then(response => {
            _this.$message.success(response.msg)
            _this.hotelList = _this.hotelList.filter(h => h.uuid !== hotel.uuid)
            _this.loadVendor(true)
            modal.destroy()
          }).catch(err => {
            console.log(err)
          })
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    handleGrantCode (hotel) {
      this.disabled = true
      grantHotelCode(hotel.uuid).then(response => {
        this.$message.success(response.msg)
        hotel.code = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.disabled = false
        this.spinning = false
      })
    },

    handleRegrant (hotel) {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '现有验证码将立即失效，确定要刷新吗?',
        centered: true,
        onOk () {
          _this.spinning = true
          _this.handleGrantCode(hotel)
        }
      })
    },

    handleRecycleCode (hotel) {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '验证码回收后该酒店将无法激活任何终端，确定要回收吗?',
        centered: true,
        onOk () {
          _this.disabled = true
          _this.spinning = true
          recycleHotelCode(hotel.uuid).then(response => {
            _this.$message.success(response.msg)
            hotel.code = null
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            _this.spinning = false
            _this.disabled = false
          })
        }
      })
    },

    handleOK () {
      this.loadVendor(true)
    },

    handleOK2 (hotel) {
      let isCreate = true
      for (let i = 0; i < this.hotelList.length; i++) {
        if (this.hotelList[i].uuid === hotel.uuid) {
          const e = this.hotelList[i]
          e.hotelName = hotel.hotelName
          e.apk = hotel.apk
          e.contact = hotel.contact
          e.address = hotel.address
          e.max = hotel.max
          e.sort = hotel.sort
          isCreate = false
          break
        }
      }
      if (isCreate) {
        this.hotelList.push(hotel)
      }
      this.hotelList.sort((a, b) => a.sort - b.sort)
      this.loadVendor(true)
    },

    handleClose (e, apk) {
      e.preventDefault()
      const _this = this
      this.$confirm({
        title: '提示',
        content: '确定要删除包名"' + apk + '"吗？',
        centered: true,
        onOk () {
          removeApk(_this.vendorId, apk).then(response => {
            _this.$message.success(response.msg)
            _this.apkList = _this.apkList.filter(a => a !== apk)
            _this.loadVendor(true)
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },

    showInput () {
      this.visible.input = true
      this.$nextTick(() => this.$refs.input.focus())
    },

    handleInputCancel () {
      this.visible.input = false
    },

    handleInputConfirm (e) {
      const apk = e.target.value.trim()
      if (!apk) {
        return
      }
      const regex = /(?=.*[.])[a-zA-z0-9.]{3,99}$/
      if (!regex.test(apk)) {
        this.$message.error(apk + '不是一个有效的包名')
        return
      }
      if (this.apkList.some(a => a === apk)) {
        this.$message.error('重复的包名')
        this.visible.input = false
        return
      }
      addApk(this.vendorId, apk).then(response => {
        this.$message.success(response.msg)
        this.apkList.push(apk)
        this.loadVendor(true)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.visible.input = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .first-col {
    margin-bottom: 2vh;

    &:after {
      position: absolute;
      top: 0.1em;
      right: 0;
      width: 0;
      height: calc(100% - 0.2em);
      content: '';
      border-right: 1px solid #e8e8e8;
    }
  }

  .vendor-item {
    &:hover {
      cursor: pointer;
      border: 1px solid #7dc6ff;
      background-color: #d2ecff;
    }

    /deep/ .ant-list-item-meta-avatar {
      margin: auto 15px auto 10px;
    }

    .avatar {
      width: 40px;
      height: 40px;
    }

    .action:hover {
      color: #1890ff;
    }

    .desc {
      font-size: 13px;
    }
  }

  .vendor-item-active {
    border: 1px solid #7dc6ff;
    background-color: #d2ecff;
  }

  .blank {
    margin-top: 100px;

    &-intro {
      margin: 2vh auto;
    }

    &-tip {
      margin: 2vh auto;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
  }

  .table-tag {
    &:not(:first-child) {
      margin-top: 4px;
    }
  }

  .table-render {
    color: rgba(0, 0, 0, .45)
  }

  .hotel-button-wrapper {
    margin-bottom: 16px;
    min-height: 32px;

    .hotel-button {
      float: right;
    }
  }

  .code-action {
    font-family: "Consolas", monospace;
    font-size: 15px;
    font-weight: 500;

    a {
      color: gray;
      margin-left: 6px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .apk-panel {
    padding: 12px 24px;

    .apk-input {
      width: 150px;
    }

    .apk-input-tag {
      background: #fff;
      border: 1px dashed rgba(0, 0, 0, 0.45);
      width: 150px;
      height: 32px;
      text-align: center;
    }

    /deep/ .ant-tag {
      font-size: 16px;
      line-height: 30px;
      height: 32px;
      margin-bottom: 16px;
    }
  }
</style>
